export enum CheckoutFormField {
  RECEIVER_FULL_NAME = 'receiverFullName',
  RECEIVER_PHONE = 'receiverPhone',
  RECEIVER_CITY = 'receiverCity',
  RECEIVER_DISTRICT = 'receiverDistrict',
  RECEIVER_NEIGHBORHOOD = 'receiverNeighborhood',
  RECEIVER_ADDRESS = 'receiverAddress',
  RECEIVER_COMPANY = 'receiverCompany',
  SENDER_PHONE = 'senderPhone',
  SENDER_FULL_NAME = 'senderFullName',
  SENDER_MAIL = 'senderMail',
  INVOICE_REQUESTED = 'invoiceRequested',
  ACCEPT_SALE_CONTRACT = 'acceptSalesContract',
  COMPANY_NAMED_INVOICE = 'companyNamedInvoice',
  INVOICE_CITY = 'invoiceCity',
  INVOICE_DISTRICT = 'invoiceDistrict',
  INVOICE_NEIGHBORHOOD = 'invoiceNeighborhood',
  INVOICE_ADDRESS = 'invoiceAddress',
  INVOICE_TITLE = 'invoiceTitle',
  TAX_OFFICE = 'taxOffice',
  TAX_NUMBER = 'taxNumber',
  RECEIVER_NOTE = 'receiverNote',
}
